/**
 * Rows | Cards — the Live tab's layout switch (20/10/2026), remembered in
 * this browser.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { LayoutGrid, Rows3 } from 'lucide-react';

import { SegmentedPills } from '@/components/ui';

import type { LiveLayout } from './live-layout';

const OPTIONS = [
  { value: 'rows', label: 'Rows', icon: Rows3 },
  { value: 'cards', label: 'Cards', icon: LayoutGrid },
] as const;

export const LiveLayoutToggle: FC<{ value: LiveLayout; onChange: (layout: LiveLayout) => void }> = ({ value, onChange }) => (
  <SegmentedPills options={OPTIONS} value={value} onChange={onChange} />
);
